import arrowleft from "../../assets/img/icons/arrow-left.svg";
import arrowright from "../../assets/img/icons/arrow-right.png";
export function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div className={`outlined-icon center ml-[24px] ${className}`} onClick={onClick}>
        <img src={arrowright} />
      </div>
    );
  }
  
export  function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div className={`outlined-icon center ${className}`} onClick={onClick}>
        {" "}<img src={arrowleft} />
      </div>
    );
  }